<template>
  <div>
    <loader v-if="!hasError"/>
    <error-page v-else :message="message"/>
  </div>
</template>

<script>
  import ErrorPage from './ErrorPage';
  import Loader from '../shared/LoginLoader';

  export default {
    components: { Loader, ErrorPage },
    data() {
      return {
        message: null,
        hasError: false
      };
    },
    mounted() {
      this.$auth.completeLogin()
        .catch((e) => {
          if (e.response && e.response.data && e.response.data.error) {
            this.message = e.response.data.error;
          } else if (e.message) {
            this.message = e.message;
          } else if (e) {
            this.message = e;
          } else {
            this.message = 'Something went wrong';
          }
          this.hasError = true;
          // So that user can refresh page to initiate new OAuth flow without
          // re-using old OAuth response in query params
          history.pushState({}, document.title, '/');
        });
    }
  };
</script>

<style scoped>

</style>
